import { render, staticRenderFns } from "./rechargeChannelGameManagement.vue?vue&type=template&id=7dc1401f&scoped=true&"
import script from "./rechargeChannelGameManagement.vue?vue&type=script&lang=js&"
export * from "./rechargeChannelGameManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc1401f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc1401f')) {
      api.createRecord('7dc1401f', component.options)
    } else {
      api.reload('7dc1401f', component.options)
    }
    module.hot.accept("./rechargeChannelGameManagement.vue?vue&type=template&id=7dc1401f&scoped=true&", function () {
      api.rerender('7dc1401f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/rechargeChannelGameManagement.vue"
export default component.exports